import * as React from 'react';
import { ListItem } from './ListItem';
import { nestedItem as style } from './style';
import { MdExpandMore, MdExpandLess } from 'react-icons/md';
export const CollapsibleList = (props) => {
    const [listOpen, toggleList] = React.useState(props.open || false);
    const open = props.open === undefined && !props.onChange ? listOpen : props.open;
    const css = style;
    return (React.createElement("div", null,
        React.createElement(ListItem, Object.assign({}, props, { action: open ? React.createElement(MdExpandLess, null) : React.createElement(MdExpandMore, null), onClick: () => {
                toggleList(!open);
                props.onChange && props.onChange(!open);
            } }), props.header),
        React.createElement("div", { className: css, style: {
                maxHeight: open ? '100vh' : '0',
            } }, props.children)));
};
//# sourceMappingURL=CollapsibleList.js.map